"use strict";

exports.__esModule = true;
var _DeviceDetailsElement = require("./DeviceDetailsElement");
Object.keys(_DeviceDetailsElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsElement[key]) return;
  exports[key] = _DeviceDetailsElement[key];
});
var _DeviceDetailsFields = require("./DeviceDetailsFields");
Object.keys(_DeviceDetailsFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsFields[key]) return;
  exports[key] = _DeviceDetailsFields[key];
});
var _EditableDeviceDetailsElement = require("./EditableDeviceDetailsElement");
Object.keys(_EditableDeviceDetailsElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditableDeviceDetailsElement[key]) return;
  exports[key] = _EditableDeviceDetailsElement[key];
});
var _DeviceDetailsWidgetThumbnail = require("./DeviceDetailsWidgetThumbnail");
Object.keys(_DeviceDetailsWidgetThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsWidgetThumbnail[key]) return;
  exports[key] = _DeviceDetailsWidgetThumbnail[key];
});
var _DeviceDetailsHeader = require("./DeviceDetailsHeader");
Object.keys(_DeviceDetailsHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsHeader[key]) return;
  exports[key] = _DeviceDetailsHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});